export default __webpack_public_path__ + "static/media/winnerModalBg.2cd3191b.jpg";